import { ref } from 'vue';
import Request from '@/services/request';
import { CATEGORY_COMMISSION_CAMPAIGN_DETAIL } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCategoryCommissionCampaignDetail() {
  const data = ref(null);
  const error = ref(null);
  const isLoading = ref(false);

  const fetchById = async (campaignId) => {
    isLoading.value = true;

    try {
      const path = `${CATEGORY_COMMISSION_CAMPAIGN_DETAIL}/${campaignId}`;
      const response = await Req.get(path, null, {
        baseURL: '/sellerofficeapi/rest',
        headers: { Accept: 'application/json' },
      });

      if (!response.status || response.status !== 200) {
        throw new Error('Network response was not OK');
      }

      data.value = response.data;
      error.value = null;
    } catch (err) {
      error.value = err || null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchById,
  };
}
